import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairings at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>Pink Tie Dinner</h1>
                  <h4 className="one">
                    October 22nd &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $80 Per Guest <span className="rules"> &nbsp;&middot;&nbsp; </span> 5 Courses
                    <br className="fullBr" />
                    Presented with Christian Services Center
                    <br className="fullBr" />
                    In Honor of Women Fighting Cancer 
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="sectionWrap insideNrw food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <p>Served on Our Patio with Live Music</p>
                <h4>Shrimp Scampi Flat Bread</h4>
                <h5>Old Bay, Roasted Garlic, Cherry Tomatoes</h5>
                <h4>Pancetta Deviled Eggs</h4>
                <h5>Beet Infused, Crispy Pancetta, Balsamic Glaze</h5>
                <p>Paired with</p>
                <h4>Mar de Frades · Rias Baixas Brut Nature 100% Albariño · Galicia, Spain</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Appetizer Course</h3>
                <h4>Fresh Local Oysters</h4>
                <h5>Pomegranate with Pink Peppercorn Mignonette</h5>
                <p>Paired with</p>
                <h4>Mar de Frades · Rias Baixas Albariño · Galicia, Spain '25</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Salad Course</h3>
                <h4>Tuna Carpaccio</h4>
                <h5>Thin Raw Tuna, Micro Green, Lemon Zest, Pickled Red Onion, Serrano Peppers, Avocado Crema</h5>
                <p>Paired with</p>
                <h4>Ramón Bilbao · Rioja del Duero Crianza · Rioja, Spain '22</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">                
                <h3>Entrée Course</h3>
                <h4>Blackened Pork Loin</h4>
                <h5>Celery Root Puree, Chard Brussels Sprouts, Balsamic Beet Coulis</h5>
                <p>Paired with</p>
                <h4>Cruz de Alba · Ribera del Duero Crianza · Castile and León, Spain '22</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">                
                <h3>Dessert Course</h3>
                <h4>Chocolate Cherry Tart</h4>
                <h5>Chocolate Ganache with a House Made, Dark Cherry Compote</h5>
                <p>Paired with</p>
                <h4>Ramón Bilbao · Rioja Crianza · Rioja, Spain '19</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
